"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserResponse = void 0;
const types_1 = require("../main/types");
const constants_1 = require("../main/constants");
class UserResponse extends types_1.UserResponseType {
    constructor(cardId, userId, responseDate, responseTime, isCorrect, studyPhase) {
        super(cardId, userId, responseTime, isCorrect, studyPhase);
        this.responseDate = responseDate;
    }
    static collectionPath(parentStudySessionDocId) {
        if (parentStudySessionDocId.length === 0) {
            return "";
        }
        // eslint-disable-next-line max-len
        return `${constants_1.constants.COLLECTION_PATH_STUDY_SESSION}/${parentStudySessionDocId}/${constants_1.constants.COLLECTION_PATH_USER_RESPONSE}`;
    }
}
exports.UserResponse = UserResponse;
UserResponse.converter = {
    toFirestore(data) {
        return {
            cardId: data.cardId,
            userId: data.userId,
            responseDate: data.responseDate,
            responseTime: data.responseTime,
            isCorrect: data.isCorrect,
            studyPhase: data.studyPhase
        };
    },
    fromFirestore(snapshot) {
        const documentData = snapshot.data();
        const id = snapshot.id;
        const cardId = documentData.cardId;
        const userId = documentData.userId;
        const responseDate = documentData.responseDate;
        const responseTime = documentData.responseTime;
        const isCorrect = documentData.isCorrect;
        const studyPhase = documentData.studyPhase;
        const data = new UserResponse(cardId, userId, responseDate, responseTime, isCorrect, studyPhase);
        data.id = id;
        return data;
    }
};
